import { lazy, Suspense } from 'react'
import { createBrowserRouter, Outlet } from 'react-router-dom'
import { AppShell } from '@/components/app-shell'
import { ErrorBoundary } from '@/components/error-boundary'

// Lazy-load all pages for code splitting
const Home = lazy(() => import('@/app/page'))
const Login = lazy(() => import('@/app/login/page'))
const Register = lazy(() => import('@/app/register/page'))
const ResetPassword = lazy(() => import('@/app/auth/reset-password/page'))
const Inventory = lazy(() => import('@/app/inventory/page'))
const InventoryLocations = lazy(() => import('@/app/inventory/locations/page'))
const InventoryDisposal = lazy(() => import('@/app/inventory/disposal/page'))
const InventoryExpiry = lazy(() => import('@/app/inventory/expiry/page'))
const InventoryMissing = lazy(() => import('@/app/inventory/missing/page'))
const InventoryRelocation = lazy(() => import('@/app/inventory/relocation/page'))
const MasterList = lazy(() => import('@/app/master-list/page'))
const InboundReceiving = lazy(() => import('@/app/inbound-receiving/page'))
const Returns = lazy(() => import('@/app/returns/page'))
const OutboundShipments = lazy(() => import('@/app/outbound-shipments/page'))
const Putaway = lazy(() => import('@/app/putaway/page'))
const PrintQueue = lazy(() => import('@/app/print-queue/page'))
const WarehouseTasks = lazy(() => import('@/app/warehouse-tasks/page'))
const Stocktake = lazy(() => import('@/app/stocktake/page'))
const Customers = lazy(() => import('@/app/customers/page'))
const Suppliers = lazy(() => import('@/app/suppliers/page'))
const Facilities = lazy(() => import('@/app/facilities/page'))
const Users = lazy(() => import('@/app/users/page'))
const Admin = lazy(() => import('@/app/admin/page'))
const Settings = lazy(() => import('@/app/settings/page'))
const SettingsGeneral = lazy(() => import('@/app/settings/general/page'))
const SettingsLocations = lazy(() => import('@/app/settings/locations/page'))
const SettingsProductAttributes = lazy(() => import('@/app/settings/products/attributes/page'))
const ReportsInventory = lazy(() => import('@/app/reports/inventory/page'))
const ReportsInbound = lazy(() => import('@/app/reports/inbound/page'))
const ReportsOutbound = lazy(() => import('@/app/reports/outbound/page'))
const ReportsMovement = lazy(() => import('@/app/reports/movement/page'))
const ReportsStocktake = lazy(() => import('@/app/reports/stocktake/page'))

function Layout() {
  return (
    <ErrorBoundary>
      <AppShell>
        <Suspense>
          <Outlet />
        </Suspense>
      </AppShell>
    </ErrorBoundary>
  )
}

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/login', element: <Login /> },
      { path: '/register', element: <Register /> },
      { path: '/auth/reset-password', element: <ResetPassword /> },
      { path: '/inventory', element: <Inventory /> },
      { path: '/inventory/locations', element: <InventoryLocations /> },
      { path: '/inventory/disposal', element: <InventoryDisposal /> },
      { path: '/inventory/expiry', element: <InventoryExpiry /> },
      { path: '/inventory/missing', element: <InventoryMissing /> },
      { path: '/inventory/relocation', element: <InventoryRelocation /> },
      { path: '/master-list', element: <MasterList /> },
      { path: '/inbound-receiving', element: <InboundReceiving /> },
      { path: '/returns', element: <Returns /> },
      { path: '/outbound-shipments', element: <OutboundShipments /> },
      { path: '/putaway', element: <Putaway /> },
      { path: '/print-queue', element: <PrintQueue /> },
      { path: '/warehouse-tasks', element: <WarehouseTasks /> },
      { path: '/stocktake', element: <Stocktake /> },
      { path: '/customers', element: <Customers /> },
      { path: '/suppliers', element: <Suppliers /> },
      { path: '/facilities', element: <Facilities /> },
      { path: '/users', element: <Users /> },
      { path: '/admin', element: <Admin /> },
      { path: '/settings', element: <Settings /> },
      { path: '/settings/general', element: <SettingsGeneral /> },
      { path: '/settings/locations', element: <SettingsLocations /> },
      { path: '/settings/products/attributes', element: <SettingsProductAttributes /> },
      { path: '/reports/inventory', element: <ReportsInventory /> },
      { path: '/reports/inbound', element: <ReportsInbound /> },
      { path: '/reports/outbound', element: <ReportsOutbound /> },
      { path: '/reports/movement', element: <ReportsMovement /> },
      { path: '/reports/stocktake', element: <ReportsStocktake /> },
    ],
  },
])
